
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { cip } from '../assets/assets';
import { Link, useNavigate } from 'react-router-dom';
import { useResendActivationCode } from '../services/auth/auth';
import { useAlert } from '../context/AlertContext';
import { useAuthStore } from '../store/authStore.js';

const ResendActivationLink = ({ onClose }) => {
    const { setTokens } = useAuthStore();
    const navigate = useNavigate();
    const { mutateAsync: resendActivation } = useResendActivationCode();
    const setAlert = useAlert();
    const [formData, setFormData] = useState({
        email: ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await resendActivation({ email: formData.email });
            setAlert({ type: 'success', message: response.message || 'Activation link resent successfully!' });
            // Staying on the page in case the user needs to request it again
            setFormData({ email: '' }); // Optionally clear formData after success
        } catch (error) {
            const err = error.response?.data?.error || 'Failed to resend activation link';
            setAlert({ type: 'error', message: err });
            console.log(err);
        }
    };

    return (
        <div className="font-['Poppins'] bg-gray-50 min-h-screen flex md:flex-row flex-col">
            {/* Image section - full width on mobile, left half on desktop */}
            <div className="w-[88%] mt-[4rem] md:mt-0 mx-auto md:w-1/2 md:max-h-screen">
                {/* Close button - visible only on mobile */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 z-10 md:hidden"
                    aria-label="Close"
                >
                    <Link to={"/clients/signin"}>
                        <X size={24} className="text-gray-800" />
                    </Link>
                </button>

                <img
                    src={cip}
                    alt="Person using keyboard"
                    className="w-full h-64 md:h-full object-cover"
                />
            </div>

            {/* Form section - full width on mobile, right half on desktop */}
            <div className="md:w-1/2 px-6 py-8 md:px-16 md:py-12 md:flex md:flex-col md:justify-center">
                <h1 className="text-2xl font-bold text-[#174568] mb-6">Resend Activation Link</h1>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-gray-700 mb-2">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Your email address"
                            className="w-full p-3 
              border border-[#C1C7CD] 
              md:border-x-0 md:border-t-0 
              md:bg-[#F2F4F8] bg-transparent 
              rounded-md md:rounded-none 
              focus:outline-none 
              focus:border-[#174568] 
              md:focus:border-b-[#174568] md:focus:border-x-0 md:focus:border-t-0"
                            required
                        />
                    </div>


                    <button
                        type="submit"
                        className="w-full bg-[#174568] hover:bg-gray-800 text-white font-medium py-3 px-4  transition-colors"
                    >
                    Send New Link
                    </button>


                        <div className="text-left mt-6">
                                <button className="text-[#001D6C] hover:underline">Didn’t get the email? Resend</button>
                        </div>



                </form>
            </div>
        </div>
    );
};

export default ResendActivationLink;


